import api from './api';

export interface PublicMatch {
  _id: string;
  title: string;
  description: string;
  type: 'deck-based' | 'custom' | 'ai-generated';
  pairsCount: number;
  tags: string[];
  attemptsCount: number;
  averageTime: number;
  bestTime: number;
  createdAt: string;
  updatedAt: string;
  creatorName: string;
  creatorEmail: string;
}

export interface MatchSearchQuery {
  q?: string;
  tags?: string;
  page?: number;
  limit?: number;
}

export interface MatchSearchResponse {
  matches: PublicMatch[];
  total: number;
  page: number;
  limit: number;
  totalPages: number;
}

class PublicMatchService {
  async searchMatches(query: MatchSearchQuery): Promise<MatchSearchResponse> {
    const params = new URLSearchParams();
    
    params.append('type', 'matches');
    if (query.q) params.append('q', query.q);
    if (query.tags) params.append('tags', query.tags);
    if (query.page) params.append('page', query.page.toString());
    if (query.limit) params.append('limit', query.limit.toString());

    const response = await api.get(`/public/search?${params.toString()}`);
    return response.data;
  }

  async getMatchById(id: string): Promise<any> {
    const response = await api.get(`/public/matches/${id}`);
    return response.data;
  }
}

export default new PublicMatchService();